import type { RecommendationBatch } from '../domain/recommendation'
import type { Visit } from '../domain/story'
import type {
  PendingStorage,
  StoryClock,
  StoryContext,
  StoryTransport,
} from './ports'
export const inactiveStoryContext: StoryContext = {
  account: null,
  visible: false,
  inCabinet: false,
  allowed: false,
  blocked: false,
}
export function automaticStoryContextReady(context: StoryContext): boolean {
  return (
    Boolean(context.account) &&
    context.visible &&
    context.inCabinet &&
    context.allowed &&
    !context.blocked
  )
}
export type RuntimeOptions = {
  onPresencePending?: () => void
  onVisit?: (clientId: string, visit: Visit | null) => void
  onRecommendations?: (batch: RecommendationBatch, clientId: string) => void
  sourceBusy?: () => boolean
  transport: StoryTransport
  storage: PendingStorage
  clock: StoryClock
  uuid: () => string
  platform: 'web' | 'pwa'
  timezone: string | null
  canNavigate: (path: string) => boolean
  navigate: (path: string) => void
}
